import { render, staticRenderFns } from "./AttachmentBatchCentre.vue?vue&type=template&id=1cfe18c6&scoped=true"
import script from "./AttachmentBatchCentre.vue?vue&type=script&lang=js"
export * from "./AttachmentBatchCentre.vue?vue&type=script&lang=js"
import style0 from "./AttachmentBatchCentre.vue?vue&type=style&index=0&id=1cfe18c6&prod&lang=css"
import style1 from "./AttachmentBatchCentre.vue?vue&type=style&index=1&id=1cfe18c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfe18c6",
  null
  
)

export default component.exports